import React from "react";
import { Feature } from "../types/type";
import { Card } from "../components/Card";
import { Button } from "../components/Button";

interface FeatureCardProps extends Feature {}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon, // previously img
}) => {
  return (
    <Card
      className="
        flex flex-col 
        h-full 
        z-10
        /* Hover scale & shadow */
        transition-transform
        duration-200
        hover:scale-[1.02]
        hover:shadow-xl
      "
    >
      {/* Header: title + optional icon on the right */}
      <div className="flex items-start justify-between mb-2">
        <h3 className="text-lg font-bold leading-tight">{title}</h3>
        {icon && <div className="ml-6 mb-6 w-10 h-10">{icon}</div>}
      </div>

      {/* Description */}
      <p className="text-gray-600 mb-6">{description}</p>

      {/* Button pinned to the bottom */}
      <div className="mt-auto">
        {/* <Button
          variant="secondary"
          className="
            transition-colors 
            duration-200 
            hover:bg-gray-200 
            active:scale-95
          "
        >
          Interested
        </Button> */}
      </div>
    </Card>
  );
};
export default FeatureCard;
